import { render, staticRenderFns } from "./JournalEntry.vue?vue&type=template&id=39f4afaf&scoped=true"
import script from "./JournalEntry.vue?vue&type=script&lang=js"
export * from "./JournalEntry.vue?vue&type=script&lang=js"
import style0 from "./JournalEntry.vue?vue&type=style&index=0&id=39f4afaf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4afaf",
  null
  
)

export default component.exports